/**
 * The agency's own identity, as printed on every outgoing document.
 *
 * ONE SOURCE. Before this file the GSTIN existed in three places and all three
 * disagreed — the invoice printed `ANEPY5126E2Z0` (no state code), Settings
 * printed `27AAGCG4471K1ZP`, and the credit-note artwork a third value. On tax
 * documents that is not a cosmetic bug, so every screen and every future
 * server-side PDF reads from here.
 *
 * It lives in `@gty/common` rather than the frontend because PDF generation is
 * mandated server-side (readme section 2), so the backend needs the same values.
 *
 * NOT YET EDITABLE. There is no company-settings table; the Settings screen
 * displays these read-only. When that table lands, this becomes its seed and
 * every consumer switches to reading the row — the point is that they all
 * already read from a single name.
 */
export const COMPANY = Object.freeze({
    /**
     * FLAGGED: `ANEPY` is a PAN whose 4th character is `P`, which denotes an
     * individual or proprietorship — a private limited company's PAN would carry
     * `C`. "Pvt Ltd" and this GSTIN are therefore inconsistent, and the legal name
     * on a tax document must match the GST registration. Confirm which is right;
     * the design's wording is kept here until then.
     */
    legalName: 'Guruji Travel Yatra Pvt Ltd',
    displayName: 'GURUJI TRAVEL YATRA',
    tagline: 'Keep Guessing,',
    taglineAccent: "Where's Next Trip?",
    gstin: '24ANEPY5126E2Z0',
    sac: '998555',
    defaultGstRate: 5,
    placeOfSupply: 'Gujarat (24)',
    phone: '+91 90999 57658',
    email: 'gurujitravelyatra@gmail.com',
    website: 'www.gurujitravelyatra.com',
    /**
     * Client-supplied wording, 2026-08-02. Two street lines plus a locality line.
     * Changed from the mockup's three-line form — do not "restore" it.
     */
    address: {
        lines: ['317, 3rd floor ABC Campus', 'Opp Rabari Colony BRTS Bus Stand'],
        city: 'Ahmedabad',
        state: 'Gujarat',
        postalCode: '380026',
    },
});
/**
 * "Ahmedabad, Gujarat-380026" — the last line of the printed address.
 *
 * Hyphen with no surrounding spaces, per the client's wording. It was an
 * em-dash with spaces; that is a visible difference on every document, so the
 * exact punctuation matters here.
 */
export function formatCompanyLocality(company = COMPANY) {
    return `${company.address.city}, ${company.address.state}-${company.address.postalCode}`;
}
/**
 * Document reference series.
 *
 * The credit-note artwork numbers documents `GTY/CN/2026/000001`, but the system
 * already issues `INV-2607-0138` and `BK-2607-0088`, and the Settings screen
 * declares the `INV-YYMM-####` series. Renumbering live documents to match a
 * mockup is not worth it, so credit notes join the existing scheme as
 * `CN-YYMM-####`.
 */
export const DOCUMENT_SERIES = Object.freeze({
    booking: 'BK-YYMM-####',
    invoice: 'INV-YYMM-####',
    voucher: 'VCH-YYMM-####',
    creditNote: 'CN-YYMM-####',
});
//# sourceMappingURL=company.js.map